import { render } from "./App.vue?vue&type=template&id=58cf8a66"
const script = {}

import "./App.vue?vue&type=style&index=0&id=58cf8a66&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__